'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { client, type RouterOutputs } from '../../utils/trpc';
import FactiiiCard from '../factiiis/FactiiiCard';
import UnifiedFactiiiPage from './UnifiedFactiiiPage';
type GeneralFactiiiPageProps = {
  slug: string;
  initialData?: RouterOutputs['factiiis']['factiiiItems'];
  initialError?: boolean;
  isEmbed: boolean;
};
const GeneralFactiiiPage = t0 => {
  const $ = _c(58);
  const {
    slug,
    initialData,
    initialError,
    isEmbed
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [closedFactiiiIds, setClosedFactiiiIds] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== slug) {
    t2 = ["factiiiItems", slug];
    t3 = () => unwrapFromResult(client.factiiis.factiiiItems.query({
      factiiiSlug: slug
    }));
    $[1] = slug;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = Boolean(slug) && !initialError;
  const t5 = !initialData;
  let t6;
  if ($[4] !== initialData || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      refetchOnMount: t5,
      initialData,
      refetchOnWindowFocus: false,
      staleTime: 300000
    };
    $[4] = initialData;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data: factiiiItemsData,
    isLoading: isItemsLoading,
    error
  } = useQuery(t6);
  let T0;
  let t10;
  let t11;
  let t7;
  let t8;
  let t9;
  let visibleSpaceFactiiis;
  let visibleUserFactiiis;
  if ($[10] !== closedFactiiiIds || $[11] !== error || $[12] !== factiiiItemsData || $[13] !== isEmbed || $[14] !== isItemsLoading || $[15] !== router || $[16] !== slug) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const factiiiList = factiiiItemsData?.factiiiList || [];
      if (isItemsLoading) {
        let t12;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t12 = <div className="flex min-h-[400px] items-center justify-center"><div className="loader" /></div>;
          $[25] = t12;
        } else {
          t12 = $[25];
        }
        let t13;
        if ($[26] !== isEmbed) {
          t13 = <AppLayout isEmbed={isEmbed}>{t12}</AppLayout>;
          $[26] = isEmbed;
          $[27] = t13;
        } else {
          t13 = $[27];
        }
        t11 = t13;
        break bb0;
      }
      if (error || !factiiiItemsData) {
        let t12;
        if ($[28] !== slug) {
          t12 = <div className="py-8 text-center"><p className="text-textSecondary">No factiiis found for "{slug}"</p></div>;
          $[28] = slug;
          $[29] = t12;
        } else {
          t12 = $[29];
        }
        let t13;
        if ($[30] !== isEmbed || $[31] !== t12) {
          t13 = <AppLayout isEmbed={isEmbed}>{t12}</AppLayout>;
          $[30] = isEmbed;
          $[31] = t12;
          $[32] = t13;
        } else {
          t13 = $[32];
        }
        t11 = t13;
        break bb0;
      }
      let t12;
      if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = factiiiId => {
          setClosedFactiiiIds(prev => [...prev, factiiiId]);
        };
        $[33] = t12;
      } else {
        t12 = $[33];
      }
      const handleCloseFactiii = t12;
      let t13;
      if ($[34] !== router || $[35] !== slug) {
        t13 = (spaceSlug, username) => {
          if (spaceSlug) {
            router.push(`/s/${spaceSlug}/f/${slug}`);
          } else {
            if (username) {
              router.push(`/user/${username}/f/${slug}`);
            } else {
              router.push(`/f/${slug}`);
            }
          }
        };
        $[34] = router;
        $[35] = slug;
        $[36] = t13;
      } else {
        t13 = $[36];
      }
      const handleFactiiiClick = t13;
      const spaceFactiiis = factiiiList.filter(_temp);
      const userFactiiis = factiiiList.filter(_temp2);
      if (factiiiList.length === 1) {
        const factiii_1 = factiiiList[0];
        const pageType = factiii_1.spaceSlug ? "space" : factiii_1.username ? "user" : "direct";
        const t14 = Boolean(error);
        let t15;
        if ($[37] !== factiiiItemsData || $[38] !== isEmbed || $[39] !== pageType || $[40] !== t14) {
          t15 = <UnifiedFactiiiPage pageType={pageType} initialData={factiiiItemsData} initialError={t14} isEmbed={isEmbed} />;
          $[37] = factiiiItemsData;
          $[38] = isEmbed;
          $[39] = pageType;
          $[40] = t14;
          $[41] = t15;
        } else {
          t15 = $[41];
        }
        t11 = t15;
        break bb0;
      }
      let t14;
      if ($[42] !== closedFactiiiIds) {
        t14 = f => !closedFactiiiIds.includes(f.id);
        $[42] = closedFactiiiIds;
        $[43] = t14;
      } else {
        t14 = $[43];
      }
      visibleSpaceFactiiis = spaceFactiiis.filter(t14);
      let t15;
      if ($[44] !== closedFactiiiIds) {
        t15 = f_0 => !closedFactiiiIds.includes(f_0.id);
        $[44] = closedFactiiiIds;
        $[45] = t15;
      } else {
        t15 = $[45];
      }
      visibleUserFactiiis = userFactiiis.filter(t15);
      T0 = AppLayout;
      t7 = isEmbed;
      let t16;
      if ($[46] !== slug) {
        t16 = <div className="mb-2"><h1 className="text-2xl font-semibold text-textPrimary">f/{slug}</h1></div>;
        $[46] = slug;
        $[47] = t16;
      } else {
        t16 = $[47];
      }
      t8 = <div className="mb-8">{t16}<p className="text-textSecondary">Found {factiiiList.length} factiiis across {spaceFactiiis.length}{" "}spaces and {userFactiiis.length} users</p></div>;
      t9 = visibleSpaceFactiiis.length > 0 && <div className="mb-8"><div className="mb-4 flex items-center gap-2"><div className="h-1 w-8 rounded-full bg-background-light" /><h2 className="text-xl font-semibold text-textPrimary">Spaces</h2><span className="rounded-full bg-background-secondary px-2 py-1 text-xs font-emphasis text-textSecondary ring-1 ring-ds-border-subtle">{visibleSpaceFactiiis.length}</span></div><div className="space-y-3">{visibleSpaceFactiiis.map(factiii_2 => <FactiiiCard key={factiii_2.id} factiii={factiii_2} onClick={() => handleFactiiiClick(factiii_2.spaceSlug)} onClose={() => handleCloseFactiii(factiii_2.id)} showCloseButton={factiiiList.length > 1} context={`s/${factiii_2.spaceSlug}`} />)}</div></div>;
      t10 = visibleUserFactiiis.length > 0 && <div className="mb-8"><div className="mb-4 flex items-center gap-2"><div className="h-1 w-8 rounded-full bg-background-light" /><h2 className="text-xl font-semibold text-textPrimary">Users</h2><span className="rounded-full bg-background-secondary px-2 py-1 text-xs font-emphasis text-textSecondary ring-1 ring-ds-border-subtle">{visibleUserFactiiis.length}</span></div><div className="space-y-3">{visibleUserFactiiis.map(factiii_3 => <FactiiiCard key={factiii_3.id} factiii={factiii_3} onClick={() => handleFactiiiClick(undefined, factiii_3.username)} onClose={() => handleCloseFactiii(factiii_3.id)} showCloseButton={factiiiList.length > 1} context={`user/${factiii_3.username}`} />)}</div></div>;
    }
    $[10] = closedFactiiiIds;
    $[11] = error;
    $[12] = factiiiItemsData;
    $[13] = isEmbed;
    $[14] = isItemsLoading;
    $[15] = router;
    $[16] = slug;
    $[17] = T0;
    $[18] = t10;
    $[19] = t11;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = visibleSpaceFactiiis;
    $[24] = visibleUserFactiiis;
  } else {
    T0 = $[17];
    t10 = $[18];
    t11 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
    visibleSpaceFactiiis = $[23];
    visibleUserFactiiis = $[24];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[48] !== visibleSpaceFactiiis.length || $[49] !== visibleUserFactiiis) {
    t12 = visibleSpaceFactiiis.length === 0 && visibleUserFactiiis.length === 0 && <div className="py-12 text-center"><div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-background-secondary"><span className="text-2xl">😔</span></div><p className="text-textSecondary">All factiiis have been closed</p></div>;
    $[48] = visibleSpaceFactiiis.length;
    $[49] = visibleUserFactiiis;
    $[50] = t12;
  } else {
    t12 = $[50];
  }
  let t13;
  if ($[51] !== T0 || $[52] !== t10 || $[53] !== t12 || $[54] !== t7 || $[55] !== t8 || $[56] !== t9) {
    t13 = <T0 isEmbed={t7}>{t8}{t9}{t10}{t12}</T0>;
    $[51] = T0;
    $[52] = t10;
    $[53] = t12;
    $[54] = t7;
    $[55] = t8;
    $[56] = t9;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  return t13;
};
export default GeneralFactiiiPage;
function _temp(factiii) {
  return factiii.spaceSlug;
}
function _temp2(factiii_0) {
  return !factiii_0.spaceSlug;
}